module.exports = __webpack_public_path__ + "media/images/pc/stores/sola/sola_link_image_flow-b2418bbd30a2930377db8bc92bda24b4.jpg";